import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation } from '@angular/core';
import { ToastComponent } from './toast.component';
import { ToastData } from './toast.service';

export interface ToastItem {
  id: number;
  data: ToastData;
  closeFn: () => void;
}

@Component({
  selector: 'app-toast-container',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [ToastComponent],
  template: `
    <div class="toast-stack">
      @for (toast of toasts(); track toast.id; let i = $index) {
        <app-toast
          [data]="toast.data"
          [index]="i"
          (closed)="removeToast(toast.id)"
        />
      }
    </div>
  `,
  styles: [`
    .toast-stack {
      position: relative;
      width: 320px;
      min-height: 0;
    }
  `]
})
export class ToastContainerComponent {
  readonly toasts = signal<ToastItem[]>([]);

  addToast(item: ToastItem): void {
    this.toasts.update(list => [item, ...list]);
  }

  removeToast(id: number): void {
    const toast = this.toasts().find(t => t.id === id);
    if (toast) {
      this.toasts.update(list => list.filter(t => t.id !== id));
      toast.closeFn();
    }
  }
}
